export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8003HD_white-3eec726fbfa34d6ccf5d68cc3a1a2a4b.webp";